import { resolveRoute } from 'vike/routing'
import type { RouteSync } from 'vike/types'

import { ebookChapters } from './chapters/manifest'

const chapterSlugs = new Set(
  ebookChapters.flatMap((chapter) => (chapter.slug ? [chapter.slug] : []))
)

export const route: RouteSync = (pageContext) => {
  const cover = resolveRoute(
    '/ebooks/company-brain/content',
    pageContext.urlPathname
  )
  if (cover.match) return cover

  const chapter = resolveRoute(
    '/ebooks/company-brain/content/@chapter',
    pageContext.urlPathname
  )
  if (chapter.match && chapterSlugs.has(chapter.routeParams.chapter)) {
    return chapter
  }

  return false
}
